export default __webpack_public_path__ + "static/media/5 Muscle Activations.131dea2d.png";